import React from 'react';
import type { Period } from '../types';

// Barra superior de seleção de período (ativo/histórico)
export function PeriodBar({ periods, viewPeriodId, setViewPeriodId, isViewingActive }: { periods:Period[]; viewPeriodId:string; setViewPeriodId:(id:string)=>void; isViewingActive:boolean }) {
  return (
    <div style={{ background:"white",borderRadius:12,padding:"10px 16px",width:"100%",maxWidth:900,marginBottom:8,boxShadow:"0 2px 8px rgba(0,0,0,.06)",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap" as const }}>
      <span style={{ fontSize:12,color:"#64748b",fontWeight:600 }}>Visualizando:</span>
      <select value={viewPeriodId} onChange={e=>setViewPeriodId(e.target.value)} style={{ flex:1,padding:"6px 10px",borderRadius:8,border:"1.5px solid #e2e8f0",fontSize:13,background:"#f8fafc",cursor:"pointer" }}>
        {periods.map(p=><option key={p.id} value={p.id}>{p.label}{p.active?" (ativo)":""}</option>)}
      </select>
      {!isViewingActive&&<span style={{ fontSize:11,background:"#fef3c7",color:"#92400e",padding:"3px 8px",borderRadius:6,fontWeight:600 }}>histórico</span>}
    </div>
  );
}
